import { render, staticRenderFns } from "./CarrinhosList.vue?vue&type=template&id=34bcee04"
import script from "./CarrinhosList.vue?vue&type=script&lang=js"
export * from "./CarrinhosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports